const config = {
    errorPlacement: kem.errorPlacement ?? 'below'
}

/**
 * Add kem-has-value class to input and textarea fields with value.
 * This class gets dynamically added and removed when the field value is changed.
 */
const inputs = document.querySelectorAll('.kem-field input:not([type=radio]):not([type=checkbox]):not([type=submit]), .kem-field textarea');
for (const input of inputs) {
    const field = input.closest('.kem-field');
    field.classList.toggle('kem-has-value', !!input.value);
    input.addEventListener('change', () => field.classList.toggle('kem-has-value', !!input.value));
    input.addEventListener('focus', () => field.classList.add('kem-has-value'));
    input.addEventListener('blur', () => field.classList.toggle('kem-has-value', !!input.value));
}

/**
 * Handle ajax form submission in modal and show validation errors if any.
 */
for (const form of document.querySelectorAll(".kem-form")) {
    handleConditionals(form);
    form.addEventListener("submit", async function (e) {
        e.preventDefault();

        const modal = form.closest(".kem-modal");
        const modalContent = modal.querySelector(".kem-modal__content");

        // Start loading animation
        modal.classList.add('kem-loading');

        // Submit form data
        const formData = new FormData(form);
        const response = await fetch(form.action, {
            headers: { 'X-WP-Nonce': formData.get('_wpnonce') },
            method: form.method,
            body: formData,
        });

        // Stop loading animation
        modal.classList.remove('kem-loading');

        if (!response.ok) {
            modalContent.innerHTML = `
                <div class="kem-error">Hoppla - hier ist etwas schiefgelaufen. Bitte lade die Seite neu und versuche es erneut.</div>
            `;
            return;
        }

        // Handle response
        const res = await response.json();

        if (res.data.html) {
            modalContent.innerHTML = res.data.html;
        } else if (!!res.data.errors) {
            showValidationErrors(res.data.errors, form);
        }
    });
}

/**
 * Render validation errors in the form.
 * 
 * @param {Array} errors 
 * @param {HTMLFormElement} form 
 */
function showValidationErrors(errors, form) {
    const globalErrorContainer = form.querySelector('.kem-errors');
    globalErrorContainer.innerHTML = '';

    // Show Global Errors
    if (errors.global) {
        for (const message of errors.global) {
            const error = document.createElement('div');
            error.classList.add('kem-error');
            error.textContent = message;
            globalErrorContainer.appendChild(error);
        }
    }

    // Handle Field Errors
    for (const [fieldName, errorMessages] of Object.entries(errors)) {
        let input = form.querySelector(`[name="${fieldName}"]`);
        if (!input) input = form.querySelector(`[name="${fieldName}[]"]`);
        const fieldWrap = input.closest('.kem-field');
        if (!fieldWrap) continue;  // Skip if field not found

        // Remove old error messages, if present
        fieldWrap.querySelector('.kem-error')?.remove();
        fieldWrap.classList.add('kem-invalid');

        // Add new error message (show last error message added per field by the server)
        const error = document.createElement('div');
        error.classList.add('kem-error');
        error.textContent = errorMessages[errorMessages.length - 1];

        // check if within fieldset
        const fieldset = input.closest('fieldset');
        
        if (!!fieldset) {
            if (config.errorPlacement === 'above') {
                fieldset.insertAdjacentElement('afterbegin', error);
            } else {
                fieldset.insertAdjacentElement('beforeend', error);
            }
            
            for (const input of fieldset.querySelectorAll('input')) {
                input.addEventListener('input', function () {
                    fieldWrap.classList.remove('kem-invalid');
                    error.remove();
                }, { once: true });
            }
        } else {
            if (config.errorPlacement === 'above') {
                input.insertAdjacentElement('beforebegin', error);
            } else {
                input.insertAdjacentElement('afterend', error);
            }

            // Auto hide error message after change in input value
            input.addEventListener('input', function () {
                fieldWrap.classList.remove('kem-invalid');
                error.remove();
            }, { once: true });
        }
    }
}

/**
 * Handle conditional logic
 */
function handleConditionals(form) {
    const data = JSON.parse(form.querySelector('script.kem-conditional-data').textContent);

    // handle visibility of fields
    const visibilityConditions = data.filter(d => {
        return d.then.targetProperty === 'isVisible' || d.then.targetProperty === 'isNotVisible';
    });

    handleVisibilityConditions(visibilityConditions, form);
}

/**
 * Handle visibility conditions
 * TODO: Conditions only work with isVisible and Checkbox Groups atm
 */
function handleVisibilityConditions(conditions, form) {
    for (const condition of conditions) {
        const [source, target] = getFields(condition, form);
        if (!source || !target) {
            continue;
        }

        if (source instanceof NodeList) {
            const hasCheckedInput = hasChecked(source);
            const showWhenChecked = condition.then.targetProperty === 'isVisible';
            if (hasCheckedInput && showWhenChecked) {
                showField(target);
            } else if (!hasCheckedInput && showWhenChecked) {
                hideField(target);
            }

            source.forEach(s => s.addEventListener('change', function () {
                const hasCheckedInput = hasChecked(source);
                if (hasCheckedInput && showWhenChecked) {
                    showField(target);
                } else if (!hasCheckedInput && showWhenChecked) {
                    hideField(target);
                }
            }));

        } else {
            throw new Error('conditionals may only have checkboxes/radios as source fields for now.');
        }
    }
}

function hasChecked(fields) {
    for (const field of fields) {
        if (field.checked) {
            return true;
        }
    }
    return false;
}

function getFields(cond, form) {
    const source = getField(cond.if, form);
    const target = getField(cond.then, form);
    return [source, target];
}

function getField(subCond, form) {
    const subject = subCond.source ? subCond.source : subCond.target;
    let field = form.querySelector(`[name="kem[${subject.replace('fields.', '')}]"]`);
    if (!field) field = form.querySelectorAll(`[name="kem[${subject.replace('fields.', '')}][]"]`); // try to find checkboxes/radios within the same field
    return field;
}

function showField(field) {
    const fieldWrapper = field.closest('.kem-field');
    fieldWrapper.classList.remove('kem-hidden');
}

function hideField(field) {
    const fieldWrapper = field.closest('.kem-field');
    fieldWrapper.classList.add('kem-hidden');
}